import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import axiosService from '../../../../../../../utils/AxiosService'
import Switch from '../../../../../../FormComponents/Switch'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'

export default observer(function BuyoutSwitch({ action }) {
  const { id } = useParams()
  const { primaryScenarioId } = useContext(CampaignContext)

  const toggleBuyout = (event) => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/actions/${action.id}`, { campaign_scenario_action: { buyout: event.target.checked, buyout_price: 0 } })
    .then(updatedAction => {
      action.buyout = updatedAction.buyout
      action.buyout_price = updatedAction.buyout_price
      toastSuccess(updatedAction.buyout ? 'Buyout enabled' : 'Buyout disabled')
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <Switch name="buyout" value={action.buyout} onChange={toggleBuyout}/>
  )
})